import React, { useEffect, useState} from 'react';
import moment from 'moment';
import 'moment-duration-format';
import { IdleTimeOutModal } from '../modal/IdleTimeOutModal';
import { appConfig } from '../authConfig';

const IdleTimeOutHandler = (props: any)=>{
    const[showModal,setShowModal]=useState(false)
    const[isLogout,setLogout]=useState(false)
    let timer: any ='undefined';
    const events= ['click','load','keydown']
    const setTime: any = moment();
    const eventHandler =(eventType:any)=>{
        //console.log(eventType)
        if(!isLogout){
            localStorage.setItem('lastInteractionTime', setTime)
            if(timer){
                props.onActive();
                startTimer();
            }
        }
        
    };
    
    //console.log(props);
    useEffect(()=>{
        addEvents();
        return (()=>{
            removeEvents();
            clearTimeout(timer);
        })
    },[])
    
    const startTimer=()=>{
        
        if(timer){
            clearTimeout(timer)
        }
        timer=setTimeout(()=>{
            let lastInteractionTime = localStorage.getItem('lastInteractionTime')
                        const diff  = moment.duration(moment().diff(moment(lastInteractionTime)));
                let timeOutInterval = props.timeOutInterval?props.timeOutInterval:6000;
            if(isLogout){
                clearTimeout(timer)
            }else{
                if(diff.milliseconds < timeOutInterval){
                    startTimer();
                    props.onActive();
                }else{
                    props.onIdle();
                    handleLogout();
                    //setShowModal(true)
                }
            }
            
        },props.timeOutInterval?props.timeOutInterval:6000)
        
        
        
        
        
    }
    const addEvents=()=>{
        
        events.forEach(eventName=>{
            window.addEventListener(eventName,eventHandler)
        })
        
        startTimer();
    }
    
    const removeEvents=()=>{
        events.forEach(eventName=>{
            window.removeEventListener(eventName,eventHandler)
        })
    };
    
    const handleContinueSession = ()=>{
          //setShowModal(false)
          setLogout(false)
    }
    const handleLogout = ()=>{
        removeEvents();
        clearTimeout(timer);
        setLogout(true)
        props.onLogout();
        setShowModal(false)
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = 'https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=' + appConfig.appEndpoint.baseUrl;
        
    }
    
    return(
        <div>
        
        <IdleTimeOutModal 
        showModal={showModal} 
        handleContinue={handleContinueSession}
        handleLogout={handleLogout}
        />
        
        </div>
        )
        
    }
    
    export default IdleTimeOutHandler;